/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowApplicationsControllerFindOneQueryResponse, WorkflowApplicationsControllerFindOnePathParams, WorkflowApplicationsControllerFindOneQueryParams, WorkflowApplicationsControllerFindOne400, WorkflowApplicationsControllerFindOne401, WorkflowApplicationsControllerFindOne403, WorkflowApplicationsControllerFindOne404 } from "../../models/workflowsController/WorkflowApplicationsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { workflowApplicationsControllerFindOne } from "../../clients/workflowsService/workflowApplicationsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const workflowApplicationsControllerFindOneQueryKey = (id: WorkflowApplicationsControllerFindOnePathParams["id"], params: WorkflowApplicationsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/workflow-applications/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type WorkflowApplicationsControllerFindOneQueryKey = ReturnType<typeof workflowApplicationsControllerFindOneQueryKey>;
export function workflowApplicationsControllerFindOneQueryOptions(id: WorkflowApplicationsControllerFindOnePathParams["id"], params?: WorkflowApplicationsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = workflowApplicationsControllerFindOneQueryKey(id, params);
  return queryOptions<WorkflowApplicationsControllerFindOneQueryResponse, ResponseErrorConfig<WorkflowApplicationsControllerFindOne400 | WorkflowApplicationsControllerFindOne401 | WorkflowApplicationsControllerFindOne403 | WorkflowApplicationsControllerFindOne404>, WorkflowApplicationsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return workflowApplicationsControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a workflow application by id
 * {@link /api/v1/workflow-applications/:id}
 */
export function useWorkflowApplicationsControllerFindOne<TData = WorkflowApplicationsControllerFindOneQueryResponse, TQueryData = WorkflowApplicationsControllerFindOneQueryResponse, TQueryKey extends QueryKey = WorkflowApplicationsControllerFindOneQueryKey>(id: WorkflowApplicationsControllerFindOnePathParams["id"], params?: WorkflowApplicationsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<WorkflowApplicationsControllerFindOneQueryResponse, ResponseErrorConfig<WorkflowApplicationsControllerFindOne400 | WorkflowApplicationsControllerFindOne401 | WorkflowApplicationsControllerFindOne403 | WorkflowApplicationsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? workflowApplicationsControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...workflowApplicationsControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<WorkflowApplicationsControllerFindOne400 | WorkflowApplicationsControllerFindOne401 | WorkflowApplicationsControllerFindOne403 | WorkflowApplicationsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}